import React, { useEffect } from "react";
import { Line } from "react-chartjs-2";

export interface BodyWeightChartProps {
  weightRows: any[];
}

export const BodyWeightChart = (props: BodyWeightChartProps) => {
  let labels = props.weightRows.map((row) => {
    const date = new Date(row.date);
    return isNaN(date.getTime()) ? row.date : date.toLocaleDateString("cs-CZ");
  });

  let values = props.weightRows.map((row) => {
    return row.weight;
  });

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Váha",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "rgba(75,192,192,1)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: values,
      },
    ],
  };

  return (
    <div className="lifeStyleListContainer">
      <Line height={60} data={data} />
    </div>
  );
};
